import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import i18n from './i18n'
import Vuetify from 'vuetify';
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@/assets/css/tailwind.css'
import '@/assets/css/style.css'
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-default.css';
import JsonExcel from 'vue-json-excel'
import VEthiopianDatePicker from 'vuetify-ethiopian-calendar';
import IdleVue from "idle-vue";
import VueApexCharts from 'vue-apexcharts'
import ApiService from "./common/api.service";
import {isLicenseExpiredActive} from "@/common/licenseExpiredState";

Vue.component('downloadExcel', JsonExcel)

Vue.component(VEthiopianDatePicker.name, VEthiopianDatePicker)

Vue.use(VueToast);
Vue.use(require('vue-moment'));
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

ApiService.init();

Vue.config.productionTip = false

Vue.use(Vuetify)

const wrapToast = (toast) => {
    if (!toast) return toast;
    const wrapFn = (fn) => (...args) => {
        if (isLicenseExpiredActive()) return;
        if (typeof fn === "function") {
            return fn.apply(toast, args);
        }
    };
    const wrapped = typeof toast === "function" ? wrapFn(toast) : {...toast};
    return Object.assign(wrapped, {
        success: wrapFn(toast.success),
        error: wrapFn(toast.error),
        warning: wrapFn(toast.warning),
        info: wrapFn(toast.info),
        open: wrapFn(toast.open),
    });
};

if (Vue.$toast) {
    Vue.$toast = wrapToast(Vue.$toast);
}
if (Vue.prototype.$toast) {
    Vue.prototype.$toast = wrapToast(Vue.prototype.$toast);
}

const eventsHub = new Vue();

Vue.use(IdleVue, {
    eventEmitter: eventsHub,
    store,
    idleTime: 1800000, // 3 seconds = 3000,
    startAtIdle: false
});

new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: h => h(App)
}).$mount('#app')
